@if (
  {
    calendar: calendar$ | async,
    period: period$ | async,
    daysWithPosts: daysWithPosts$ | async,
  };
  as data
) {
  <div class="flex h-full flex-col">
    <div class="mb-4 flex items-center justify-between">
      <svg-icon
        app-icon-button
        (click)="prevMonth(data)"
        [dialogClose]="true"
        class="block h-9 w-9 text-theme-500 cursor-pointer!"
        [ngClass]="{ 'opacity-40': minMonth(data) }"
        [src]="'icon-arrow-left' | icon"
      ></svg-icon>
      <div class="flex gap-2">
        @if (loading()) {
          <app-skeleton class="w-fit!" [showLabel]="false"></app-skeleton>
        }
        <h1 class="text-lg font-medium capitalize">{{ data.calendar | dateTranslate: 'MMMM yyyy' }}</h1>
      </div>
      <svg-icon
        app-icon-button
        (click)="nextMonth(data)"
        class="block h-9 w-9 text-theme-500 cursor-pointer!"
        [ngClass]="{ 'opacity-40': maxMonth(data) }"
        [src]="'icon-arrow-right' | icon"
      ></svg-icon>
    </div>
    <div class="h-full">
      <ol class="grid h-full grid-cols-7 place-items-center gap-1">
        @for (day of week; track day) {
          <li class="text-center text-base font-medium capitalize text-base-gray-400">
            {{ 'geral.dias.' + day | translate }}
          </li>
        }
        @for (blank of blankDays$ | async; track $index) {
          <div>&nbsp;</div>
        }
        @for (day of days$ | async; track $index) {
          <li
            (click)="onChangeDay(day)"
            app-flat-button
            class="relative text-md color-title flex flex-col h-10 w-10 items-center justify-center rounded-md text-center shadow-none"
            [ngClass]="{
              'bg-base-status-info-500! text-white!': daySelected(day),
              'bg-theme-300 text-white font-semibold': isToday(day),
              'border border-solid border-base-status-info-400 font-semibold': hasPosts(day, data.daysWithPosts),
              'text-subtitle!': isWeekend(day),
            }"
          >
            {{ day.getDate() }}
          </li>
        }
      </ol>
    </div>
  </div>
}
